// Alerts ---------------------------------------------------
export const ALERT_SUCCESS = 'ALERT_SUCCESS';
export const ALERT_ERROR = 'ALERT_ERROR';
export const ALERT_CLEAR = 'ALERT_CLEAR';

// Webgis ---------------------------------------------------
export const CHANGE_BACKGROUND = 'CHANGE_BACKGROUND';
export const GET_FEATURE_INFO = 'GET_FEATURE_INFO';
export const GET_FEATURE_INFO_STARTED = 'GET_FEATURE_INFO_STARTED';
export const GET_FEATURE_INFO_SUCCESS = 'GET_FEATURE_INFO_SUCCESS';
export const GET_FEATURE = 'GET_FEATURE';
export const GET_FEATURE_START = 'GET_FEATURE_START';
export const GET_FEATURE_SUCCESS = 'GET_FEATURE_SUCCESS';
export const CHANGE_FEATURE_PANEL = 'CHANGE_FEATURE_PANEL';
export const CLOSE_POPUP = 'CLOSE_POPUP';

// LayerItems ---------------------------------------------------
export const UPDATE_LAYER_FILL_COLOR = 'UPDATE_LAYER_FILL_COLOR';
export const UPDATE_MAP_BOUNDS = 'UPDATE_MAP_BOUNDS';
export const UPDATE_LAYER_VISIBILITY = 'UPDATE_LAYER_VISIBILITY';
export const UPDATE_LAYER_BORDER_COLOR = 'UPDATE_LAYER_BORDER_COLOR';
export const UPDATE_LAYER_BORDER_WIDTH = 'UPDATE_LAYER_BORDER_WIDTH';
export const UPDATE_MAP_LAYERS_ORDER = 'UPDATE_MAP_LAYERS_ORDER';
export const UPDATE_MAP_LAYERS_STARTED = 'UPDATE_MAP_LAYERS_STARTED';
export const UPDATE_MAP_LAYERS_SUCCESS = 'UPDATE_MAP_LAYERS_SUCCESS';
export const UPDATE_MAP_LAYERS_FAILED = 'UPDATE_MAP_LAYERS_FAILED';
export const UPDATE_MAP_TABLE = 'UPDATE_MAP_TABLE';
export const REMOVE_LAYER_ITEM = 'REMOVE_LAYER_ITEM';
export const SHOW_SEARCH_RESULT_ITEM = 'SHOW_SEARCH_RESULT_ITEM';
export const CLEAR_SEARCH_RESULT_ITEM = 'CLEAR_SEARCH_RESULT_ITEM';
export const UPDATE_LAYER_VIEWPARAMS = 'UPDATE_LAYER_VIEWPARAMS';
export const ADD_LAYER_LOADING = 'ADD_LAYER_LOADING';
export const REMOVE_LAYER_LOADING = 'REMOVE_LAYER_LOADING';
export const GET_MAP_LAYERS = 'GET_MAP_LAYERS';
export const GET_MAP_LAYERS_STARTED = 'GET_MAP_LAYERS_STARTED';
export const GET_MAP_LAYERS_SUCCESS = 'GET_MAP_LAYERS_SUCCESS';
export const GET_MAP_LAYERS_FAILED = 'GET_MAP_LAYERS_FAILED';
export const SAVE_QUERY_RESULT = 'SAVE_QUERY_RESULT';
export const SAVE_QUERY_RESULT_SUCCESS = 'SAVE_QUERY_RESULT_SUCCESS';
export const UPDATE_MAP_KEY = 'UPDATE_MAP_KEY';
export const CHANGE_LAYER_OPACITY = 'CHANGE_LAYER_OPACITY';
export const GET_FIRE_YEARS = 'GET_FIRE_YEARS';
export const GET_FIRE_YEARS_SUCCESS = 'GET_FIRE_YEARS_SUCCESS';
export const GET_FIRE_POINTS = 'GET_FIRE_POINTS';
export const GET_FIRE_POINTS_SUCCESS = 'GET_FIRE_POINTS_SUCCESS';
export const SHOW_FIRE_POLYGONS = 'SHOW_FIRE_POLYGONS';
export const SHOW_FIRE_POINTS = 'SHOW_FIRE_POINTS';
export const TOGGLE_LEGEND = 'TOGGLE_LEGEND';

// Statistics ---------------------------------------------------
export const GET_ADMIN_WITH_FIRES = 'GET_ADMIN_WITH_FIRES';
export const GET_ADMIN_WITH_FIRES_SUCCESS = 'GET_ADMIN_WITH_FIRES_SUCCESS';
export const GET_STATISTICS = 'GET_STATISTICS';
export const GET_ADMIN_WITH_FIRES_STARTED = 'GET_ADMIN_WITH_FIRES_STARTED';
export const GET_STATISTICS_SUCCESS = 'GET_STATISTICS_SUCCESS';
export const UPDATE_SIMPLE_VARIABLE = 'UPDATE_SIMPLE_VARIABLE';
export const CHANGE_CLC_YEAR = 'CHANGE_CLC_YEAR';

// LoginRegister ---------------------------------------------------
export const SHOW_LOGIN_REGISTER = 'SHOW_LOGIN_REGISTER';
export const HIDE_LOGIN_REGISTER = 'HIDE_LOGIN_REGISTER';
export const CHECK_LOGIN = 'CHECK_LOGIN';
export const REGISTER_USER = 'REGISTER_USER';
export const LOGGED_IN = 'LOGGED_IN';
export const LOGGED_OUT = 'LOGGED_OUT';
export const GET_USER_FROM_LOCAL_STORAGE = 'GET_USER_FROM_LOCAL_STORAGE';
export const ACCOUNT_ACTIVATION = 'ACCOUNT_ACTIVATION';
export const SHOW_CONFIRMATION = 'SHOW_CONFIRMATION';
export const SEND_RESET_PASSWORD_EMAIL = 'SEND_RESET_PASSWORD_EMAIL';
export const UPDATE_PASSWORD = 'UPDATE_PASSWORD';
export const SHOW_LOADING_SPINNER = 'SHOW_LOADING_SPINNER';
export const HIDE_LOADING_SPINNER = 'HIDE_LOADING_SPINNER';

// Admin ---------------------------------------------------
export const GET_VERSIONS = 'GET_VERSIONS';
export const GET_VERSIONS_SUCCESS = 'GET_VERSIONS_SUCCESS';
export const UPDATE_ADMIN_SIMPLE_VARIABLE = 'UPDATE_ADMIN_SIMPLE_VARIABLE';
export const CREATE_NEW_VERSION = 'CREATE_NEW_VERSION';
export const CREATE_VERSION_SUCCESS = 'CREATE_VERSION_SUCCESS';
export const CLEAR_VERSION = 'CLEAR_VERSION';
export const CHANGE_DATABASE_VERSION = 'CHANGE_DATABASE_VERSION';

// Dropzone ---------------------------------------------------
export const REMOVE_FILE_FROM_FILE_LIST = 'REMOVE_FILE_FROM_FILE_LIST';
export const FILE_ADDED_TO_LIST = 'FILE_ADDED_TO_LIST';
export const FILE_DROPED_TO_LIST = 'FILE_DROPED_TO_LIST';
export const UPLOAD_PROGRESS = 'UPLOAD_PROGRESS';
export const UPLOAD_FILES_FAILED = 'UPLOAD_FILES_FAILED';
export const CLEAR_FILES_LIST = 'CLEAR_FILES_LIST';
export const UPLOADED_FILES_SUCCESS = 'UPLOADED_FILES_SUCCESS';
export const REMOVE_DIRECTORY_FROM_UPLOADS = 'REMOVE_DIRECTORY_FROM_UPLOADS';